import i18n from 'i18next';

const DATE_PRESETS = [
  ['common.datePresets.today', 'today', 'Today'],
  ['common.datePresets.yesterday', 'yesterday', 'Yesterday'],
  ['common.datePresets.last7Days', '7', 'Last 7 Days'],
  ['common.datePresets.last30Days', '30', 'Last 30 Days'],
  ['common.datePresets.thisMonth', 'thisMonth', 'This Month'],
  ['common.datePresets.lastMonth', 'lastMonth', 'Last Month'],
  ['common.custom', 'custom', 'Custom'],
];

export const getDatePresetOptions = t => DATE_PRESETS.map(([key, value, defaultValue]) => {
  const label = t(key, { defaultValue });
  return {
    text: label,
    value,
    name: label,
  };
});

export const getDevicesResourceName = (t = i18n.t.bind(i18n)) => (
  t('pageTitles.devices', { defaultValue: 'Devices' })
);
